export class ArrayHelper {


  static makeBatches(array: any[], maxCount: number) {
    let result: any[] = [];
    if (array.length > maxCount) {
      const batch = array.splice(0, maxCount);
      result.push(batch);
    } else result.push(array);
    return result;
  }

  static getStrings(array: any[], propertyName: string) {
    let result: string[] = [];
    for (const item of array) {
      const val: string = item[propertyName];
      if (result.indexOf(val) === -1) result.push(val);
    }
    result = result.sort((a, b) => {
      return (a?.toUpperCase() || "").localeCompare(b?.toUpperCase() || "")
    });

    return result;
  }

  static getIds(array: any[], propertyName: string) {
    const result: number[] = [];
    for (const item of array) {
      const id = parseInt(item[propertyName], 0);
      if (id > 0 && result.indexOf(id) === -1) result.push(id);
    }

    return result;
  }

  static getOne(array: any[], propertyName: string, value: any) {
    for (const item of array) if (item[propertyName] === value) return item;
    return null
  }

  static getOneMultiCondition(array: any[], propertyNames: string[], values: any[]) {
    for (const item of array) {
      let match = true;
      for (let i = 0; i < propertyNames.length; i++) {
        if (item[propertyNames[i]] !== values[i]) match = false;
      }
      if (match) return item;
    }
    return null
  }

  static limit(array: any[], count: number) {
    const result: any[] = []
    for (let i = 0; i < array.length && i < count; i++) result.push(array[i]);
    return result;
  }

  static getAll(array: any[], propertyName: string, value: any) {
    const result: any[] = []
    for (const item of array) if (item[propertyName] === value) result.push(item);
    return result;
  }

  static getAllContaining(array: any[], propertyName: string, value: any) {
    const result: any[] = []
    for (const item of array) if (item[propertyName].toString().toLowerCase().indexOf(value.toLowerCase()) > -1) result.push(item);
    return result;
  }

  static getAllArray(array: any[], propertyName: string, values: any[]) {
    const result: any[] = []
    for (const item of array) if (values.indexOf(item[propertyName]) > -1) result.push(item);
    return result;
  }

  static fillArray(contents: string, length: number) {
    const result = [];
    for (let i = 0; i < length; i++) result.push(contents);
    return result;
  }

  static sort(array: any[], propertyName: string, desc: boolean) {
    array.sort((a, b) => {
      if (desc) return (a[propertyName] > b[propertyName]) ? -1 : 1;
      else return (a[propertyName] < b[propertyName]) ? -1 : 1;
    });
  }

}
